
import 'babel-polyfill'
import dva from 'dva'
import '@/pages/styles/reset.less'
import '@/utils/bdCourierConfig'
import resizeRoot from '@/utils/resizeRoot'
import { createBrowserHistory } from 'history'
import * as Models from '@/pages/models'
import * as Routers from '@/routers'
import { polyfillHistroyVersionsForIOS } from './utils/IssJsBridgeCourier/utils'
import '@/utils/vconsoleConfig'
import '@flashex-fe-comp/issdesign/lib/toast/style/index.css'
import 'antd-mobile/dist/antd-mobile.css'
import Moment from 'moment'
import 'moment/locale/zh-cn'
// test
Moment.locale('zh-cn')
polyfillHistroyVersionsForIOS()
resizeRoot()

const Initialize = (Routers) => {
  // 1. Initialize
  const app = dva({
    history: createBrowserHistory({
      basename: '/courierView'
    })
  })

  // 2. Plugins
  // app.use({});

  // 3. Model
  Object.keys(Models).map(item => app.model(Models[item]))

  // 4. Router
  app.router(Routers.default)

  // 5. Start
  app.start('#root')
}
Initialize(Routers)

if (module.hot) {
  module.hot.accept()
}
